module.exports = "/images/sophia.webp?05a3f6a4e517d9f0884537d113b00a61";